import React from 'react'
import "./index.css"

export default function Work() {
    return (
        <section id="work" className="section is-medium">
            <p className="title  is-family-code has-text-green">Some Things I've Built</p>
            <div class="columns is-mobile">
                <div class="column is-11
is-offset-1">
                    <div className="columns is-vcentered">
                        <div className="column">
                            <div class="notification is-primary">
                                <p className="bd-notification title is-2 has-text-light is-family-code">EMIE v2.1</p>
                                <text className='is-family-code'>EMIE2.0 is an Web based tool built for curating and visualizing relationship knowledge data, with a preloaded data of meta-analytic findings of drivers for organizational performance outcomes. This Python web based tool has three pages: Instructions, Knowledge graph input, and Knowledge graph output.</text>
                                <br /><br /><a href="https://github.com/mandgenikhil/emie" className='button btn is-family-code'><span class="icon is-small">
                                    <i class="fa fa-lg fa-github"></i>
                                </span><span className='is-family-code'>Github</ span></a>
                                <span /><a href="https://mighty-badlands-12109.herokuapp.com/home" className='button btn is-family-code ml-3'><span class="icon is-small">
                                    <i class="fa fa-lg fa-globe"></i>
                                </span><span className='is-family-code'>Website</ span></a>
                            </div>
                        </div>
                        <div className="column">
                            {/* <p className="bd-notification title is-2 has-text-light">EMIE v2.1</p> */}
                        </div>
                    </div>
                    <div className="columns is-vcentered">
                        <div className="column">
                            {/* <p className="bd-notification title is-2 has-text-light has-text-centered">Voicebot</p> */}
                        </div>
                        <div className="column">
                            <div class="notification is-primary">
                                <p className="bd-notification title is-2 has-text-light is-family-code">Voicebot</p>
                                <text className='is-family-code'>Project aims to solve customer support queries and services through a Voicebot for insurance domain organizations. Using GCP dialogue flow and Engine app cloud services</text>
                                <br /><br /><a href="https://github.com/mandgenikhil/VoiceBot" className='button btn is-family-code'><span class="icon is-small">
                                    <i class="fa fa-lg fa-github"></i>
                                </span><span>Github</ span></a>
                                <span /><a href="https://modest-clarke-dfef89.netlify.app/" className='button btn is-family-code ml-3'><span class="icon is-small">
                                    <i class="fa fa-lg fa-globe"></i>
                                </span><span>Website</ span></a>
                            </div>
                        </div>

                    </div>
                    <div className="columns is-vcentered">
                        <div className="column">
                            <div class="notification is-primary">
                                <p className="bd-notification title is-2 has-text-light is-family-code">Covid Tracker India-Web App</p>
                                <text className='is-family-code'>Designed and develop Covid tracker app (India) to check the official count of active user using official India Covid data API’s</text>
                                <br /><br /><a href="https://github.com/mandgenikhil/covid-tracker.git" className='button btn is-family-code'><span class="icon is-small">
                                    <i class="fa fa-lg fa-github"></i>
                                </span><span>Github</ span></a>
                                <span /><a href="https://romantic-golick-2d496e.netlify.app/" className='button btn is-family-code ml-3'><span class="icon is-small">
                                    <i class="fa fa-lg fa-globe"></i>
                                </span><span>Website</ span></a>
                            </div>
                        </div>
                        <div className="column">
                            {/* <p className="bd-notification title is-2 has-text-light">EMIE v2.1</p> */}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}
